import { Modal } from './Modal'

/** Confirmation dialog: data + callbacks only. Uses shared Modal for all UI. */
export class ConfirmationModal {
  constructor(private modal: Modal) {}

  show(title: string, message: string, buttonLabels: [string, string], onConfirm: () => void, onCancel?: () => void): void {
    const onClose = () => {
      onCancel?.()
      this.modal.hide()
    }
    this.modal.show((dialog) => {
      dialog.appendChild(
        Modal.createHeader(title, onClose),
      )
      const content = Modal.createContent()
      content.appendChild(Modal.createMessage(message))
      content.appendChild(
        Modal.createButtons([
          {
            label: buttonLabels[0],
            variant: 'secondary',
            onClick: onClose,
          },
          {
            label: buttonLabels[1],
            onClick: () => this.modal.hide(onConfirm),
          },
        ]),
      )
      dialog.appendChild(content)
    })
  }

  hide(): void {
    this.modal.hide()
  }
}
